





































import { Component, Prop } from 'vue-property-decorator';
import { IPolicy } from 'admiral-core';
import Multiselect from 'vue-multiselect';
import Avatar from '@/components/common/Avatar.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { CheckIcon } from 'vue-feather-icons';
import { PolicyApi } from '@/services/PolicyApi';

@Component({
  components: { Multiselect, Avatar, CheckIcon },
})
export default class PolicySelect extends mixins(BaseMixin) {
  @Prop({ type: Boolean, default: () => false })
  multiple!: boolean;

  @Prop()
  policy!: IPolicy | IPolicy[];

  policies: IPolicy[] = [];

  updatePolicy(policy: IPolicy | IPolicy[]) {
    this.$emit('update-policy', policy);
  }

  // isSelected(id: string) {
  //   if (!this.u) {
  //     return false;
  //   }
  //   if (Array.isArray(this.u)) {
  //     return this.u.find((user: IUser) => user.id === id);
  //   } else {
  //     return this.u.id === id;
  //   }
  // }

  async findPolicies(str: string) {
    try {
      const response = await PolicyApi.getPolicies({
        search: str,
        // users: [this.user],
        agency: this.user.agency,
        limit: 10,
        showDemo: this.$store.getters['PreferencesModule/getShowDemo'],
      });
      this.policies = response.data;
    } catch (e) {
      console.log(e);
    }
  }
}
